
let $1f0dc3b9307be026$var$toggleBtn = document.querySelector("#navbar-toggle");
let $1f0dc3b9307be026$var$collapse = document.querySelector("#navbar-collapse");
$1f0dc3b9307be026$var$toggleBtn.onclick = ()=>{
    $1f0dc3b9307be026$var$collapse.classList.toggle("hidden");
    $1f0dc3b9307be026$var$collapse.classList.toggle("flex");
};
// add active class on navbar item if it is the current page
let $1f0dc3b9307be026$var$navbarItems = document.querySelectorAll("#navbar-collapse a");
$1f0dc3b9307be026$var$navbarItems.forEach((item)=>{
    if (window.location.href === item.href) {
        item.classList.add("active");
        item.classList.remove("nav");
    } else {
        item.classList.remove("active");
        item.classList.add("nav");
    }
});
// add year to #footer-year
let $1f0dc3b9307be026$var$date = new Date();
let $1f0dc3b9307be026$var$year = $1f0dc3b9307be026$var$date.getFullYear();
let $1f0dc3b9307be026$var$footerYear = document.querySelector("#footer-year");
$1f0dc3b9307be026$var$footerYear.innerHTML = $1f0dc3b9307be026$var$year;
// Video Modal Functionality
document.addEventListener('DOMContentLoaded', ()=>{
    const videoModal = document.getElementById('video-modal');
    const videoPlayer = document.getElementById('modal-video-player');
    if (videoModal && videoPlayer) {
        // Get all buttons that open the modal
        const modalToggleButtons = document.querySelectorAll('[data-modal-toggle="video-modal"]');
        // Add click event listeners to each button
        modalToggleButtons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                // Get the video source from the button's data attribute
                const videoSrc = button.getAttribute('data-video-src');
                // Set the video source
                if (videoSrc) {
                    videoPlayer.src = videoSrc;
                    videoPlayer.load(); // Reload the video element
                }
                // Toggle the modal visibility
                videoModal.classList.toggle('hidden');
                videoModal.classList.toggle('flex');
                // If opening the modal, add overflow hidden to body
                if (!videoModal.classList.contains('hidden')) document.body.classList.add('overflow-hidden');
                else {
                    document.body.classList.remove('overflow-hidden');
                    // Pause video when modal is closed
                    videoPlayer.pause();
                }
            });
        });
        // Close modal when clicking outside the content
        videoModal.addEventListener('click', (e)=>{
            if (e.target === videoModal) {
                videoModal.classList.add('hidden');
                videoModal.classList.remove('flex');
                document.body.classList.remove('overflow-hidden');
                videoPlayer.pause();
            }
        });
        // Close modal with Escape key
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && !videoModal.classList.contains('hidden')) {
                videoModal.classList.add('hidden');
                videoModal.classList.remove('flex');
                document.body.classList.remove('overflow-hidden');
                videoPlayer.pause();
            }
        });
    }
});


//# sourceMappingURL=about-us.4777d711.js.map
